var _dec, _dec2, _dec3, _dec4, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { inject, injectable } from 'inversify';
import TYPES from 'di/types';
import { setMomentLocale } from 'srcJs/components/moment';
import { translate } from '@collaborator/npm_modules/dist/components/translate';
var Translate = (_dec = injectable(), _dec2 = function _dec2(target, key) {
  return inject(TYPES.NetworkService)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [void 0]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  function Translate(networkService) {
    _classCallCheck(this, Translate);

    this.networkService = networkService;
  }

  _createClass(Translate, [{
    key: "setLang",
    value: function setLang(lang) {
      this.lang = lang;
      translate.setLanguage(lang);
    }
  }, {
    key: "format",
    value: function format(category, message) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return translate.translate(category, message, params);
    }
  }, {
    key: "formatForReact",
    value: function formatForReact(category, message) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return translate.translateForReact(category, message, params);
    }
  }, {
    key: "load",
    value: function load() {
      return this.networkService.getSimple("/translate/telegram/".concat(this.lang, ".json"), {
        baseURL: null
      }).then(function (response) {
        translate.setTranslations(response.data);
        setMomentLocale();
        return response;
      });
    }
  }]);

  return Translate;
}()) || _class) || _class) || _class) || _class);
export default Translate;